import { jsonReplacerBigIntToString } from "@/utils/json-utils";
import { QueryKey } from "@tanstack/react-query";

export interface ConnectQueryKeyOptions {
  transport?: string;
  serviceName: string;
  methodName?: string;
  input?: Record<string, unknown> | "skipped";
  headers?: Record<string, string>;
  cardinality?: "finite" | "infinite";
}

/**
 * Custom hash function for query keys that handles BigInt values.
 * TanStack Query uses JSON.stringify internally, which throws on BigInt.
 */
export function hashGrpcQueryKey(queryKey: readonly unknown[]): string {
  return JSON.stringify(queryKey, jsonReplacerBigIntToString);
}

export function getConnectQueryKeyOptions(queryKey: QueryKey): ConnectQueryKeyOptions | null {
  if (queryKey[0] !== "connect-query") {
    return null;
  }

  const maybeOptions = queryKey[1];
  if (maybeOptions == null || typeof maybeOptions !== "object" || Array.isArray(maybeOptions)) {
    return null;
  }

  const options = maybeOptions as Partial<ConnectQueryKeyOptions>;
  if (typeof options.serviceName !== "string") {
    return null;
  }

  if (options.methodName != null && typeof options.methodName !== "string") {
    return null;
  }

  if (
    options.cardinality != null &&
    options.cardinality !== "finite" &&
    options.cardinality !== "infinite"
  ) {
    return null;
  }

  return options as ConnectQueryKeyOptions;
}
